export const buttonMetrics = {
  height: 44,
  gutter: 8
};

export const inputMetrics = {
  height: 44
};
